<template>
  <div class="animated fadeIn row">
    <nav class="navbar navbar-light bg-light w-full" style="padding: .5rem 1rem;margin-top: -20px;">
      <a class="navbar-brand" href="#"><b>รีวิว </b></a>
      <ul class="nav nav-pills" role="tablist">
        <li class="nav-item">
          <router-link :to="{ name: 'ReviewAdd'}"><button class="btn btn-lg btn-primary" type="button"><i class="fas fa-plus"></i>
              เพิ่ม</button></router-link>
        </li>
      </ul>
    </nav>
    <div v-for="valueReview in data.reviews" class="card col-md-12" :key="valueReview.id">
      <div class="card-body">
        <div class="row bd-example2">
          <div class="col-sm-12 col-lg-4">
              <img v-if="valueReview.image&&valueReview.image!=null" v-bind:src="valueReview.image" @error="imageLoadError" class="d-block w-full">
              <img v-if="valueReview.image===null" v-bind:src="no_image.src" class="d-block w-full">
          </div>          
          <div class="col-sm-12 col-lg-8">
            <div id="spy-example2" data-spy="scroll" data-target="#list-example" data-offset="0">
              <h4 class="text-center">
                <b v-if="valueReview.reviewer&&valueReview.reviewer!=''">รีวิวโดย {{valueReview.reviewer}}</b>
              </h4>
              <div class="col-sm-12" v-if="valueReview.content!=''" style="overflow: hidden">
                <p>
                  <span v-html="valueReview.content"></span>
                </p>
              </div>
              <label v-if="valueReview.review_date">&nbsp;&nbsp;<b>วันที่รีวิว:</b> {{ valueReview.review_date |
                moment('timezone', 'Asia/Bangkok', 'L LT')}}</label>
              <label v-if="valueReview.created_at">&nbsp;&nbsp;<b>วันที่สร้าง:</b> {{ valueReview.created_at |
                moment('timezone', 'Asia/Bangkok', 'L LT')}}</label>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="col-sm-12 col-lg-12 row">
              <div class="col-sm-12 col-lg-4">
                  <div v-if="valueReview.rating" class="col-sm-12 col-lg-12 row my-3 text-center">
                    <div class="col-md-12 row">
                      <div class="ml-2" v-for="rating of valueReview.rating" :key="rating">
                          <i class="fas fa-star" style="color:#ffc107"></i>
                      </div><b class="ml-3"><i>{{valueReview.rating}} ดาว</i></b></div>
                  </div>
              </div>
              <div class="col-sm-12 col-lg-8">
                  <div class="row">
                    <div class="col-lg-6 col-sm-6">
                      <b-btn @click="$router.push({ name: 'ReviewEdit',params: { id: valueReview.id }})" class="mt-3"
                        variant="outline-primary" block><i class="fas fa-edit"></i> แก้ไข</b-btn>
                    </div>
                    <div class="col-lg-6 col-sm-6">
                      <b-btn @click="alertDeleteReview(valueReview.id,valueReview.reviewer)" class="mt-3" variant="outline-primary"
                        block><i class="fas fa-trash-alt"></i> ลบ</b-btn>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-bind:title="review.alert.title" ref="alert" hide-footer v-model="review.alert.active" @ok="review.alert.active = false">
      <div v-if="review.alert.load==false">
        <div class="row">
          <div class="col-md-12 text-center">
            <span v-html="review.alert.detail"></span>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6" v-if="review.alert.open.active">
            <b-btn class="mt-3" variant="outline-primary" block @click="submitDelete"><span v-html="review.alert.open.name"></span></b-btn>
          </div>
          <div class="col-lg-3" v-if="review.alert.open.active==false"></div>
          <div class="col-lg-6" v-if="review.alert.close.active">
            <b-btn class="mt-3" variant="outline-secondary" block @click="closeAlert"><span v-html="review.alert.close.name"></span></b-btn>
          </div>
        </div>
      </div>
      <div v-if="review.alert.load">
        <div class="loader-container-4tiles clearfix">
          <div class="square s9 rounded"></div>
          <div class="square s2 rounded"></div>
          <div class="square s1 rounded"></div>
          <div class="square s6 rounded"></div>
        </div>
      </div>
    </b-modal>
    <div v-if="data.per_page&&data.per_page!=null&&data.per_page>1" class="w-full">
      <b-pagination align="center" :total-rows="data.per_page*data.per_page" v-on:input="getReviews" v-model="data.page"
        :per-page="data.per_page"></b-pagination>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueMoment from 'vue-moment'
  import moment from 'moment-timezone'
  Vue.use(VueMoment, {
    moment,
  })
  export default {
    data() {
      return {
        load: 0,
        no_image:{
          src: 'https://d2gvpkbpfjsf4i.cloudfront.net/web-builder/no-image.png'
        },
        review: {
          id: null,
          name: '',
          alert: {
            title: '',
            open: {
              active: false,
              name: ''
            },
            close: {
              active: false,
              name: ''
            },
            image: null,
            action: '',
            detail: '',
            active: false,
            load: false
          }
        },
        lang: this.$route.query.lang,
        authorization: 'Bearer '+localStorage.getItem('z_token'),
        data: {
          page: this.$route.query.page,
          per_page: null,
          reviews: {}
        }
      }
    },
    mounted() {
      if(!this.lang){
        this.lang = 'th'
      }
      this.checkLang()
      this.startLoad(1)
      this.getReviews()
    },
    methods: {
      checkLang(){
        if(!this.lang){
          this.lang='th'
        }
      },
      checkLoad() {
        this.load = this.load - 1
        if (this.load <= 0) {
          this.load = 0
          this.$Progress.finish()
        }
      },
      startLoad(count) {
        this.load = count
        this.$Progress.start()
      },
      failLoad() {
        this.$Progress.fail()
      },
      closeAlert() {
        this.$refs.alert.hide()
      },
      alertDeleteReview(reviewID, reviewName) {
        this.review.id = reviewID
        this.review.name = reviewName
        this.review.alert.title = 'การลบรีวิว'
        this.review.alert.detail = 'คุณต้องการลบรีวิวของ <b>' + reviewName + '</b> ใช่หรือไม่?'
        this.review.alert.open.active = true
        this.review.alert.close.active = true
        this.review.alert.open.name = 'ยืนยันการลบ'
        this.review.alert.close.name = 'ยกเลิกการลบ'
        this.review.alert.active = true
      },
      submitDelete() {
        this.review.alert.load = true
        this.deleteReviewByID()
      },
      getReviews() {
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/reviews', {
          params: {
            page: this.data.page,
            per_page: this.data.per_page,
            lang: this.lang
          },
          headers: {
            Authorization: this.authorization
          }
        }).then(function (response) {
          this.lang = response.data.json.lang
          this.checkLoad()
          moment.locale(this.lang)
          this.data.page = parseInt(response.data.json.page)
          this.data.per_page = parseInt(response.data.json.per_page)
          this.$router.replace({ name: 'ReviewList',query: { page: this.data.page,lang: this.lang }})
          this.data.reviews = response.data.json.data
        }).catch(function (error) {
          this.failLoad()
          this.review.alert.title = 'การดึงข้อมูลรีวิว'
          this.review.alert.detail = 'ไม่สามารถทำการดึงรีวิวได้!'
          this.review.alert.open.active = false
          this.review.alert.close.name = 'ปิด'
          this.review.alert.active = true
        })
      },
      deleteReviewByID() {
        if (this.review.id && this.review.id != '') {
          this.startLoad(2)
          this.$http.delete(process.env.VUE_APP_API_URL + 'api/v1/review/' + this.review.id, {
            headers: {
              Authorization: this.authorization
            }
          }).then(function (response) {
            this.checkLoad()
            this.review.alert.load = false
            this.getReviews()
            this.review.alert.detail = 'ทำการลบรีวิวหมายเลข: ' + response.body.json.review.id + ' เรียบร้อย'
            this.review.alert.open.active = false
            this.review.alert.close.name = 'ปิด'
            this.review.alert.active = true
          }).catch(function (error) {
            this.failLoad()
            this.review.alert.detail = 'ไม่สามารถทำการลบรีวิวได้!'
            this.review.alert.open.active = false
            this.review.alert.close.name = 'ปิด'
            this.review.alert.active = true
          })
        }
      },
      imageLoadError(event){
        event.target.src = this.no_image.src
      }
    }
  }

</script>
